import { render, staticRenderFns } from "./IconMetrics.vue?vue&type=template&id=78fade79&scoped=true"
import script from "./IconMetrics.vue?vue&type=script&lang=js"
export * from "./IconMetrics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fade79",
  null
  
)

export default component.exports